module.exports = __webpack_public_path__ + "static/person-a90298b78d2cf40504db274fcbf75593.png";